module.exports = __webpack_public_path__ + "static/img/1.56d6fa0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/1.png
// module id = 1RoD
// module chunks = 0